module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "close-on-content-click": false,
      "min-width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('button', _vm._g({
          staticClass: "dropdown"
        }, on), [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("more_vert")])], 1)]
      }
    }]),
    model: {
      value: (_vm.model.value),
      callback: function($$v) {
        _vm.$set(_vm.model, "value", $$v)
      },
      expression: "model.value"
    }
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "dropdown__open"
  }, [_c('v-list-item-group', [_c('v-list-item', {
    on: {
      "click": _vm.redirectToDevice
    }
  }, [_c('v-list-item-title', [_vm._v("Screen Mirroring")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.webkitFeaturesEnabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({}, on), [_c('v-list-item', {
          attrs: {
            "disabled": !_vm.webkitFeaturesEnabled
          },
          on: {
            "click": _vm.redirectToMap
          }
        }, [_c('v-list-item-title', [_vm._v("Show on Map")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Update yout client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.webkitFeaturesEnabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({}, on), [_c('v-list-item', {
          attrs: {
            "disabled": !_vm.webkitFeaturesEnabled
          },
          on: {
            "click": _vm.redirectToTerminal
          }
        }, [_c('v-list-item-title', [_vm._v("Terminal")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Update yout client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.webkitFeaturesEnabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({}, on), [_c('v-list-item', {
          attrs: {
            "disabled": !_vm.webkitFeaturesEnabled
          },
          on: {
            "click": _vm.redirectToApps
          }
        }, [_c('v-list-item-title', [_vm._v("Apps")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Update yout client")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.webkitFeaturesEnabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('span', _vm._g({}, on), [_c('v-list-item', {
          attrs: {
            "disabled": !_vm.webkitFeaturesEnabled
          },
          on: {
            "click": _vm.redirectToFiles
          }
        }, [_c('v-list-item-title', [_vm._v("Files")])], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Update yout client")])]), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'device-details-modal',
        params: {
          publicID: _vm.model.ID,
          filter: _vm.filter
        }
      }
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-list-item-title', [_vm._v("Details")])], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'new-group-modal',
        params: {
          credential: [_vm.model.ID],
          filter: _vm.filter
        }
      }
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-list-item-title', [_vm._v("New Group")])], 1), _vm._v(" "), _c('v-menu', {
    staticClass: "dropdown__submenu dropdown__open",
    attrs: {
      "offset-x": "",
      "open-on-click": "",
      "close-on-click": "",
      "close-on-content-click": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-list-item', _vm._g({
          attrs: {
            "disabled": _vm.groups.length === 0
          }
        }, on), [_c('v-list-item-title', [_c('v-layout', {
          attrs: {
            "justify-space-between": ""
          }
        }, [_c('div', [_vm._v("Move To Group")]), _vm._v(" "), _c('v-icon', [_vm._v("chevron_right")])], 1)], 1)], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticClass: "dropdown__open"
  }, [_vm._l((_vm.groups), function(item, index) {
    return (_vm.groupID !== item.ID) ? _c('v-list-item', {
      key: index,
      staticClass: "devices__group-item",
      on: {
        "click": function($event) {
          return _vm.addDeviceToGroup(item.ID)
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.Name))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.groupID !== 0) ? _c('v-list-item', {
    staticClass: "devices__nogroup-item",
    on: {
      "click": function($event) {
        return _vm.addDeviceToGroup(0)
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Remove")])], 1) : _vm._e()], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90ac3216","hasScoped":false}!./app/components/dropdown/template.html
// module id = 397
// module chunks = 0